import { type FormEvent } from 'react';

export default function ContactSection() {
  const formUrl = 'https://readdy.ai/api/form/d9m364sit35ii3jdle4g';

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypot = (form.elements.namedItem('phone_alt') as HTMLInputElement)?.value?.trim();
    if (honeypot) return;

    const formData = new FormData(form);
    formData.delete('phone_alt');

    try {
      const resp = await fetch(formUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });
      const text = await resp.text();
      let parsed;
      try { parsed = JSON.parse(text); } catch { parsed = null; }
      if (resp.ok && parsed?.code === 'OK') {
        form.reset();
        alert('提交成功！感谢您的投稿，我们会尽快处理。');
      } else {
        const errMsg = parsed?.meta?.message || parsed?.message || '提交失败，请稍后重试';
        alert(errMsg);
      }
    } catch {
      alert('网络错误，请稍后重试');
    }
  };

  return (
    <section id="contact" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">投稿联系</h2>
            <p className="text-sm md:text-base text-foreground-600">
              欢迎推荐优质视频资源，或对久久视频、小蓝视频、豆花视频接入提出建议
            </p>
          </div>
          <div className="bg-background-50 rounded-2xl p-6 md:p-8 border border-background-200/70">
            <form data-readdy-form onSubmit={handleSubmit}>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
                <div>
                  <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">昵称</label>
                  <input
                    id="contact-name"
                    name="name"
                    type="text"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                    placeholder="你的昵称"
                  />
                </div>
                <div>
                  <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">邮箱</label>
                  <input
                    id="contact-email"
                    name="email"
                    type="email"
                    required
                    className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors"
                    placeholder="your@email.com"
                  />
                </div>
              </div>
              <div className="mb-4">
                <label htmlFor="contact-type" className="block text-sm font-medium text-foreground-800 mb-1.5">类型</label>
                <select
                  id="contact-type"
                  name="type"
                  required
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors cursor-pointer"
                >
                  <option value="">请选择</option>
                  <option value="resource">资源推荐</option>
                  <option value="feedback">意见反馈</option>
                  <option value="cooperation">合作咨询</option>
                  <option value="other">其他</option>
                </select>
              </div>
              <div className="mb-5">
                <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">留言内容</label>
                <textarea
                  id="contact-message"
                  name="message"
                  required
                  maxLength={500}
                  rows={4}
                  className="w-full px-4 py-2.5 text-sm bg-background-100 border border-background-200/70 rounded-lg focus:outline-none focus:border-primary-300 focus:ring-1 focus:ring-primary-200 transition-colors resize-none"
                  placeholder="请描述你想推荐的内容或建议..."
                ></textarea>
                <p className="text-xs text-foreground-500 mt-1">最多500字</p>
              </div>

              <div className="honeypot-field">
                <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" aria-hidden="true" readOnly />
              </div>

              <button
                type="submit"
                className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-background-50 font-semibold text-sm rounded-lg transition-colors cursor-pointer whitespace-nowrap"
              >
                提交信息
              </button>
            </form>
          </div>
        </div>
      </div>
    </section>
  );
}